import { type GroupBase, createGroupBase } from 'models/group';
import type { GroupContentObjectDetailDataObject, GroupContentObjectListDataObject } from 'models/service';
import { type BaseContentObject, createBaseContentObject } from '../base-content-object';
import type { ContentObject } from '../content-object';

export type GroupContentObjectDetail = {
  contentableType: 'Group';
  group: GroupBase;
} & BaseContentObject;

export const createGroupContentObjectDetail = (data: GroupContentObjectDetailDataObject): GroupContentObjectDetail =>
  createGroupContentObjectList(data);

export type GroupContentObjectList = {
  contentableType: 'Group';
  group: GroupBase;
} & BaseContentObject;

export const createGroupContentObjectList = (data: GroupContentObjectListDataObject): GroupContentObjectList => ({
  contentableType: data.contentable_type,
  ...createBaseContentObject(data),
  group: createGroupBase(data.group),
});

export const isGroupContentObject = (
  contentObject: ContentObject | GroupContentObjectDetail | GroupContentObjectList,
): contentObject is GroupContentObjectDetail | GroupContentObjectList => contentObject.contentableType === 'Group';
